import {
    commonReducer,
    initialCommonState,
    type commonAction,
    type commonState,
} from "@/hooks/reducers/common.reducer";
import type { facilitatorPanelData } from "./types.props";

interface panelState extends commonState {
    data: facilitatorPanelData | null;
    simulationIdForPerformance?: number | string;
}

export const initialState: panelState = {
    ...initialCommonState,
    data: null,
};

type panelAction =
    | commonAction
    | { type: "SET_DATA"; payload: facilitatorPanelData };

export const panelReducer = (
    state: panelState,
    action: panelAction,
): panelState => {
    const commonState = commonReducer(state, action as commonAction);
    if (commonState !== state) {
        return { ...state, ...commonState };
    }

    switch (action.type) {
        case "SET_DATA": {
            return {
                ...state,
                data: action.payload,
                simulationIdForPerformance: action.payload.relevant_simulation_id_for_performance || undefined,
            };
        }
        case "RESET_ERROR":
            return initialState;
        default:
            return state;
    }
};
